import { DateRangeFilter } from 'app/constants/delegation/dateRangeFilter'

export const getDateRangeFilterName = (
  dateRangeFilter: DateRangeFilter,
  translate: (string) => string,
): string => {
  const text: string = DateRangeFilter[dateRangeFilter]
  return translate(`dateRangeFilter.${text}`)
}
